module.exports = __webpack_public_path__ + "img/3.8c21bcf4.jpg";